import { render, staticRenderFns } from "./InformationPopup.vue?vue&type=template&id=fad9d58c"
import script from "./InformationPopup.vue?vue&type=script&lang=ts"
export * from "./InformationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports